import * as _ from 'lodash';

export const HereMapAuthToken = {
  appId: 'eBWPXwy5NTgs66Q56LPO',
  appCode: 'sRJPc2zq91rLlD61rf2SkQ',
};

export const MapBoxConfig = {
  mapboxAccessToken:
    'pk.eyJ1IjoiaW1raXJhbjIyIiwiYSI6ImNqZzRxaDRseDdybHMycW1zZ3RpdDlxMjYifQ.C2PQ36BtOIv5xPoXJlneDg',
};

export const LayerControls: {
  key: string;
  value: string;
  className: string;
}[] = [
  {
    key: 'Light',
    value: 'light',
    className: 'Light-mode',
  },
  {
    key: 'Dark',
    value: 'dark',
    className: 'Dark-mode',
  },
];

export const MapBoxLayers = [
  { scheme: 'mapbox.satellite' },
  { scheme: 'mapbox.streets' },
  { scheme: 'mapbox.light' },
  { scheme: 'mapbox.dark' },
  { scheme: 'mapbox.satellite' },
  { scheme: 'mapbox.streets-satellite' },
  { scheme: 'mapbox.wheatpaste' },
  { scheme: 'mapbox.comic' },
  { scheme: 'mapbox.outdoors' },
  { scheme: 'mapbox.run-bike-hike' },
  { scheme: 'mapbox.pencil' },
  { scheme: 'mapbox.pirates' },
  { scheme: 'mapbox.emerald' },
  { scheme: 'mapbox.high-contrast' },
  { scheme: 'mapbox.streets-basic' },
];

export const TILE_LAYER_URL = (
  options: {
    scheme: string;
    resource: string;
    resolution?: number;
    ppi?: number;
  } = {
    scheme: 'terrain.day',
    resource: 'trucknopttile',
  },
) => {
  const appId = HereMapAuthToken.appId;
  const appCode = HereMapAuthToken.appCode;
  const tileResolution = options.resolution || 256;
  const format = 'png8';
  const mapId = 'newest';
  const ppi = options.ppi || 72; //72 is the default value set by heremaps
  const tilePath = `/maptile/2.1/${options.resource}/${mapId}/${options.scheme}/{z}/{x}/{y}/${tileResolution}/${format}?app_id=${appId}&app_code=${appCode}&ppi=${ppi}`;
  const schemeStart = options.scheme.split('.')[0];
  let tileServer = 'base.maps.api.here.com';
  if (
    schemeStart === 'satellite' ||
    schemeStart === 'terrain' ||
    schemeStart === 'hybrid'
  ) {
    tileServer = 'aerial.maps.api.here.com';
  }
  const s = _.random(3) + 1;
  const attributionPath = `https://developer.here.com/`;
  return {
    tile: `https://${s}.${tileServer}${tilePath}`,
    attribution: `<a href="${attributionPath}">HERE</a>`,
  };
};
